import React, { Component } from 'react'
import { remove, all } from 'ramda'
import { Icon, Input, Modal, Button, Select } from '@driftt/tide-core-legacy'
import './style.styl'

const emptyList = { accountListName:null, accountListId: null }

class SFDCAccountSyncModal extends Component {

  state = {
    listsToSync: [emptyList],
    targetList: true
  }

  isValid = () => {
    let { listsToSync } = this.state
    listsToSync.pop() // remove null value from list
    const hasBothValues = ({ accountListId, accountListName }) => !!accountListName && !!accountListId
    return all(hasBothValues)(listsToSync)
  }

  addNewList = () => {
    this.setState(prevState => ({
      listsToSync: [...prevState.listsToSync, emptyList]
    }))
  }

  removeListToSync = index => {
    this.setState(prevState => ({
      listsToSync: remove(index, 1, prevState.listsToSync)
    }))
  }

  renderNewListSelect = ({ accountListId }, index) => {
    const { lists } = this.props
    const { targetList, listsToSync } = this.state

    const onStateSet = () => {
      this.addNewList()
    }
    const listOptions = lists.map(({ label, id }) => ({ label, value: id }))
    const updateListToSync = (option, index) => {
      this.setState(prevState => {
        const updatedLists = [...prevState.listsToSync]
        updatedLists[index] = { accountListId: option.value, accountListName: option.label, targeted: targetList }
        return { listsToSync: updatedLists }
      }, () => onStateSet())
    }

    return (
      <span className="sfdc-accounts-sync-add-list" key={accountListId}>
        <Select
          onChange={value => updateListToSync(value, index)}
          value={accountListId}
          options={listOptions}
          placeholder={"Select an Account List"}
          clearable={false}
        />
        { listsToSync.length > 1 &&
          <span onClick={() => this.removeListToSync(index)}>
            { listsToSync[index].accountListName !== null &&
              <Icon className="account-list-close-icon" width={11} name="close" />
            }
          </span>
        }
      </span>
    )
  }

  onSetTargetList = () => {
    this.setState(prevState => ({
      targetList: !prevState.targetList
    }))
  }

  sendToServer = () => {
    const { onCloseClick } = this.props
    const { listsToSync, targetList } = this.state

    if (this.isValid()) {
      const correctedTargeting = listsToSync.map(list => {
        list.targeted = targetList
        return list
      })
      onCloseClick(correctedTargeting)
    }
  }

  render() {
    const { onCancelClick } = this.props
    const { listsToSync, targetList } = this.state

    const syncAllText = () => (
        <span>
          Sync these accounts as targeted ABM accounts.
          <a href="https://help.drift.com/playbooks/drift-abm-personalize-your-playbooks-to-greet-prospects" >
            &nbsp;Learn More
          </a>
        </span>
    )

    return (
      <div>
        { <Modal
          className={"sfdc-account-sync-modal"}
          open={true}
          size={"small"}
          onClose={onCancelClick}
          >
          <div className="account-list-modal-holder">
            <h2>Synced Salesforce Account Lists</h2>
            <h4>Choose an Account List to sync from Salesforce</h4>
            {listsToSync.map(this.renderNewListSelect)}

            <Input
              type="checkbox"
              label={syncAllText()}
              onChange={this.onSetTargetList}
              checked={targetList}
              size={"small"}

            />

            <Button
              type="secondary"
              onClick={this.sendToServer}
              className="modal-button-container"
              style={{ marginRight:'5px' }}
              disabled={listsToSync[0].accountListName === null ? true : false}
              >
              Sync
            </Button>

            <Button type="tertiary" onClick={onCancelClick} className="modal-button-container">
              Cancel
            </Button>
          </div>
        </Modal> }
      </div>
    )
  }
}

export default SFDCAccountSyncModal



// WEBPACK FOOTER //
// ./src/scripts/components/SFDC/SFDCAccountSyncModal/index.js